import { Certificate } from '@components';
import React, { useState } from 'react';
import { useLocation } from 'react-router-dom';
import generatePDF, { Margin } from 'react-to-pdf';

import { getDataFromLS } from '../components/CookiesModal/CookiesModal.propTypes';

const CERTIFICATE_ELEMENT_ID = 'content-id';

const PDF_GENERATION_OPTIONS = {
  canvas: {
    mimeType: 'image/png',
    qualityRatio: 1,
  },
  filename: 'certificate.pdf',
  method: 'save',
  page: {
    format: 'letter',
    margin: Margin.SMALL,
    orientation: 'landscape',
  },
};

const createFileName = ({ language, name }) =>
  `${name}_${language || ''}_certificate.pdf`;

export const useCertificateDownload = ({
  date,
  elementId = CERTIFICATE_ELEMENT_ID,
  isPossibleToDownload = true,
} = {}) => {
  const { state } = useLocation();

  const [isDownloading, setIsDownloading] = useState(false);
  const language = getDataFromLS('certificateLanguage');
  const name = getDataFromLS('certificateName');

  const getTargetElement = () => document.getElementById(elementId);

  const handleCertificateDownload = async () => {
    if (!isPossibleToDownload) {
      return;
    }

    try {
      setIsDownloading(true);
      await generatePDF(getTargetElement, {
        ...PDF_GENERATION_OPTIONS,
        filename: createFileName({ language, name }),
      });

      setIsDownloading(false);
    } catch (error) {
      setIsDownloading(false);
    }
  };

  const titleByLevel = {
    'Officer Level': 'OfficerLevel',
    'Soldier Level': 'SoldierLevel',
  };

  const title = titleByLevel[state?.title] || state?.title;

  const hiddenElement = (
    <div style={{ opacity: '0', position: 'fixed', zIndex: -100 }}>
      <div id="content-id">
        <Certificate
          date={date}
          isPDFGenerationVariant
          language={language}
          name={name}
          title={title}
          withExtraMargin
        />
      </div>
    </div>
  );

  return {
    hiddenElementToDownload: hiddenElement,
    isDownloading,
    onDownload: handleCertificateDownload,
  };
};
